const ACTIVE_STATUS = 'active'

export const workspaceServices = [
  {
    key: 'logis',
    label: 'LOGIS',
    title: 'AONE Logis',
    description: '오더 및 운송',
    icon: 'local_shipping'
  },
  {
    key: 'fulfillment',
    label: 'FULFILLMENT',
    title: 'AONE Fulfillment',
    description: '상품·SKU 및 포장',
    icon: 'inventory_2'
  },
  {
    key: 'inventory',
    label: 'INVENTORY',
    title: 'AONE Inventory',
    description: '입고·재고 및 이력',
    icon: 'warehouse'
  }
]

export const toBoolean = (value) => {
  if (typeof value === 'boolean') return value
  if (typeof value === 'number') return value === 1

  const normalized = String(value ?? '').trim().toLowerCase()
  return ['1', 'true', 'y', 'yes', ACTIVE_STATUS, 'enabled'].includes(normalized)
}

const normalizeStatus = (value) => {
  const normalized = String(value ?? '').trim().toLowerCase()
  if (['active', 'enabled', 'approved'].includes(normalized)) return ACTIVE_STATUS
  if (['pending', 'requested', 'review'].includes(normalized)) return 'pending'
  if (['suspended', 'disabled', 'blocked'].includes(normalized)) return 'suspended'
  return 'unregistered'
}

const readExplicitStatus = (session, serviceKey) => {
  const statuses = session?.service_statuses ?? session?.serviceStatuses ?? {}
  return session?.[`${serviceKey}_service_status`] ??
    session?.[`${serviceKey}ServiceStatus`] ??
    statuses?.[serviceKey]
}

const readScope = (session) => String(
  session?.partner_domain_scope ??
  session?.partnerDomainScope ??
  session?.service_scope ??
  session?.serviceScope ??
  session?.menu_scope ??
  session?.menuScope ??
  ''
).toLowerCase().replace(/\s+/g, '')

export const resolveServiceStatus = (session = {}, serviceKey) => {
  const authLevel = Number(session?.authLevel ?? 0)
  if (authLevel >= 90) return ACTIVE_STATUS

  const explicitStatus = readExplicitStatus(session, serviceKey)
  if (explicitStatus !== undefined && explicitStatus !== null && explicitStatus !== '') {
    return normalizeStatus(explicitStatus)
  }

  const contractKey = `has_${serviceKey}_contract`
  if (session?.[contractKey] !== undefined && session?.[contractKey] !== null) {
    return toBoolean(session[contractKey]) ? ACTIVE_STATUS : 'unregistered'
  }

  const scope = readScope(session)
  if (scope) {
    const hasService = scope.includes('both') || scope.includes('all') ||
      scope.includes(serviceKey) ||
      (serviceKey === 'fulfillment' && scope.includes('fulfill'))
    return hasService ? ACTIVE_STATUS : 'unregistered'
  }

  // 기존 세션에는 Inventory 계약 필드가 없으므로 명시적으로 등록된 경우에만 허용한다.
  if (serviceKey === 'inventory') return 'unregistered'

  // 기존 사용자와의 호환: 계약 정보가 전혀 없으면 기존 Logis/Fulfillment 메뉴를 유지한다.
  return ACTIVE_STATUS
}

export const hasServiceAccess = (session, serviceKey) => (
  resolveServiceStatus(session, serviceKey) === ACTIVE_STATUS
)

export const resolveServiceFromPath = (path = '') => {
  if (path.startsWith('/admin/inventory')) return 'inventory'
  if (path.startsWith('/admin/fulfillment/packing/receiving')) return 'logis'
  if (path.startsWith('/admin/fulfillment') || path.startsWith('/admin/packing')) return 'fulfillment'

  const logisPrefixes = [
    '/admin/parcel-info',
    '/admin/dashboard',
    '/admin/console',
    '/admin/hbl-no-manage',
    '/admin/hs-code-manage',
    '/admin/freight-manage',
    '/admin/pickup-request-list',
    '/admin/courier-manage',
    '/admin/pickup-manage',
    '/admin/location-manage',
    '/admin/manage-schedule'
  ]
  if (logisPrefixes.some(prefix => path.startsWith(prefix))) return 'logis'
  return null
}

export const resolveServiceHome = (serviceKey, session = {}) => {
  const isAdmin = Number(session?.authLevel ?? 0) >= 90
  if (serviceKey === 'fulfillment') {
    return isAdmin ? '/admin/fulfillment/operations' : '/admin/fulfillment/home'
  }
  if (serviceKey === 'inventory') return '/admin/inventory'
  return '/admin/parcel-info'
}

export const serviceStatusLabel = (status) => ({
  active: '사용 중',
  pending: '승인 대기',
  suspended: '이용 중지',
  unregistered: '미등록'
}[status] || '미등록')
